import { render, staticRenderFns } from "./a-sort-icon.vue?vue&type=template&id=7ed287b0&"
import script from "./a-sort-icon.vue?vue&type=script&lang=js&"
export * from "./a-sort-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports